import { Button, Tooltip } from "antd";
import { bool, func, object, string } from "prop-types";
import { useCallback, useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { SearchInput, SearchPanel } from "./styled";

const Search = ({
  queryParams,
  setQueryParams,
  loadingSearchResults,
  clearAll,
  searchTooltip,
  searchPlaceholder,
  parentComponentName,
}) => {
  const intl = useIntl();
  const [searchInput, setSearchInput] = useState(queryParams.query);

  useEffect(() => {
    setSearchInput(queryParams.query);
  }, [queryParams.query]);

  const handleClearAll = useCallback(() => {
    clearAll();
    setSearchInput("");
  }, [clearAll]);

  return (
    <SearchPanel>
      <Tooltip placement={"bottom"} title={searchTooltip}>
        <SearchInput
          data-test-id={`${parentComponentName}-search-input`}
          placeholder={searchPlaceholder}
          onSearch={(value) =>
            setQueryParams({ ...queryParams, query: value, page: 1 })
          }
          onChange={(e) => setSearchInput(e.target.value)}
          value={searchInput}
          loading={loadingSearchResults}
        />
      </Tooltip>
      <Button
        data-test-id={`${parentComponentName}-search-clear-button`}
        onClick={handleClearAll}
      >
        {intl.formatMessage({ id: "general.clearAll" })}
      </Button>
    </SearchPanel>
  );
};

Search.propTypes = {
  queryParams: object.isRequired,
  setQueryParams: func.isRequired,
  loadingSearchResults: bool,
  clearAll: func,
  searchTooltip: string,
  searchPlaceholder: string,
  parentComponentName: string,
};

export default Search;
